// This file is auto-generated during build to inject the bootstrap configuration
// @ts-ignore - VITE_BOOTSTRAP_CONFIG is defined at build time
window.BoostrapConfig = VITE_BOOTSTRAP_CONFIG;
